<div class="filter-group-card" *ngIf="_filterGroup as group">
  <div class="filter-group-actions">
    <div ngbDropdown>
      <span
        class="mdi mdi-dots-horizontal"
        ngbTooltip="Filter Group Actions"
        container="body"
        ngbDropdownToggle
        id="filter-group-actions"
      >
      </span>
      <div ngbDropdownMenu aria-labelledby="filter-group-actions">
        <div
          *ngFor="let action of filterGroupActions"
          [ngbTooltip]="action.tooltip(!!cacheLoaded, _filterGroup)"
          container="body"
        >
          <button
            class="dropdown-item btn btn-link"
            (click)="action.onClick(group)"
            [disabled]="action.disabled(!!cacheLoaded)"
          >
            {{ action.displayName }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="filter-group-card-content" (click)="apply(group)">
    <h5 class="mb-0">
      <nf-inline-edit
        [alwaysShowButtons]="false"
        [editable]="true"
        [transparent]="true"
        [editButtonClickOnly]="true"
        [disablePopover]="false"
        [ngbTooltip]="name"
        container="body"
        (save)="updateName(group)"
      >
        <input type="text" class="form-control" [(ngModel)]="name" />
      </nf-inline-edit>
    </h5>
  </div>
  <div
    class="description"
    (click)="onDescriptionClick()"
    (mouseover)="onDescriptionHover()"
    [ngbTooltip]="descriptionOnTooltip"
    container="body"
  >
    <span class="mdi mdi-information text-primary"></span>
    <span class="mdi mdi-pencil-circle text-success"></span>
  </div>
</div>
